import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ScreenLockLandscapeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"screen_lock_landscape"}/>
}
